import { forwardRef } from 'react';

export const SubheadingMd = forwardRef<HTMLDivElement, { title: string }>(
  ({ title, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className="flex items-center justify-between gap-4"
        {...props}
      >
        <h3 className="inline-block text-xl font-medium text-foreground">
          {title}
        </h3>
      </div>
    );
  },
);

SubheadingMd.displayName = 'SubheadingMd';
